import React from 'react'

import './WorkflowStepDivider.scss'

const WorkflowStepDivider = ({ stepNumber, label }) => (
  <div className="creative-direction-chat__step-divider">
    <span />
    <strong>{`Step ${stepNumber}: ${label}`}</strong>
    <span />
  </div>
)

export default WorkflowStepDivider
